<template>
  <AttrSwitch
    class="mt-2.5"
    label="超出范围是否显示"
    :value="renderRule"
    :disabled="!!disabled"
    @change="setRenderRule"
  />
</template>

<script setup lang="ts">
import { Shape } from '@/services/shape';
import { canUse } from '@/utils/can-use.utils';
import { computed, PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const renderRule = computed(() => {
  const { attrs } = props.shape;
  const deviceLightSource = canUse('pointer-light-source').valid;
  let curRenderRule;
  if (deviceLightSource) {
    curRenderRule = attrs.renderRule
      ? attrs.renderRule
      : (attrs.pointerRegionNum ?? 0) < 2
      ? attrs._hideWhenOutRange
        ? 'hideWhenOutRange'
        : 'alwaysShow'
      : 'hideWhenOutRange';
  } else {
    curRenderRule = attrs.renderRule
      ? attrs.renderRule
      : attrs._hideWhenOutRange
      ? 'hideWhenOutRange'
      : 'alwaysShow';
  }
  return curRenderRule == 'alwaysShow';
});

const setRenderRule = (v: boolean) => {
  const { attrs } = props.shape;
  if (attrs._hideWhenOutRange) {
    props.shape.setAttrs({
      _hideWhenOutRange: !v
    });
  } else {
    props.shape.setAttrs({
      renderRule: v ? 'alwaysShow' : 'hideWhenOutRange'
    });
  }
};
</script>

<style scoped></style>
